import { useLayoutEffect, useRef } from 'react';
/**
 * Returns focus to whatever held it when a Radix dialog opened.
 *
 * Radix's modal Content always prevents FocusScope's own restore on close and
 * focuses its `<Trigger>` instead. A dialog opened programmatically has no
 * Trigger, so focus falls to <body> and keyboard users lose their place. When
 * there is no Trigger, the element focused at open is remembered and focused
 * again on close. It is read in a layout effect on `open`: every layout effect
 * runs before any passive one, so the opener is recorded before a field inside
 * the dialog autofocuses in its mount effect and before FocusScope's own
 * open auto-focus. A consumer close handler runs first and can call
 * `preventDefault()` to take over.
 */
export function useReturnFocus({ open, hasTrigger, onCloseAutoFocus, }) {
    const openerRef = useRef(null);
    useLayoutEffect(() => {
        if (!open)
            return;
        const active = document.activeElement;
        openerRef.current =
            active instanceof HTMLElement && active !== document.body ? active : null;
    }, [open]);
    return {
        onCloseAutoFocus: (event) => {
            onCloseAutoFocus?.(event);
            const opener = openerRef.current;
            openerRef.current = null;
            if (event.defaultPrevented || hasTrigger || opener === null || !opener.isConnected)
                return;
            event.preventDefault();
            opener.focus({ preventScroll: true });
        },
    };
}
//# sourceMappingURL=return-focus.js.map